export default {
	searchParams: SEARCH_PARAMS(),

	cmpnMstList: [], //캠페인 목록
	cmpnMstPopup: CMPN_MST_POPUP(), //캠페인상세목록
	excelDownLoadList: [], //엑셀다운로드시 해더저장
	pagingInfo: PAGING_INFO(), //페이지 정보
	//occuRegnListPop: [], //발생지역 콤보박스
	causCdListPop: [], //원인코드 콤보박스
	prbmTypeListPop: [], //문제유형 콤보박스
	cmpnTypeListPop: [], //캠페인유형 콤보박스
	tymaCdListPop: [], //기종 콤보박스

	opCodeList: [], //op코드 리스트
	pmcIdList: [], //PMC Id.리스트
	cmpnPartList: [], //교환부품 리스트
	popUpOpCdList: [], //팝업 OP코드 리스트

	popupParams: POPUP_PARAMS(), //교환부품정보 팝업 정보
	opCdSearchParams: OP_CD_SEARCH_PARAMS(), //op코드 팝업 검색 정보
	popUpPagingInfo: POP_UP_PAGING_INFO() //op코드 팝업 페이지 정보
};

function POPUP_PARAMS() {
	return {
		show: false,
		selectedRow: {},
		opCd: '',
		lts: '',
		mtrlCst: '',
		stdCst: ''
	};
}

function SEARCH_PARAMS() {
	return {
		cmpnNm: null /*캠페인명*/,
		partNm: null /*원인부품명*/,
		cmpnType: null /*ctype*/
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function CMPN_MST_POPUP() {
	return {
		deleteBtn: false, //삭제버튼권한
		cmpnNo: '', //캠페인번호
		cmpnNm: '', //캠페인명
		prbmType: '', //문제유형
		prbmTypeNm: '', //
		cmpnType: '', //캠페인유형
		cmpnTypeNm: '', //
		strtDd: '', //시작일
		endDd: '', //종료일
		occuRegn: '', //발생지역
		occuRegnNm: '', //
		dtlRegn: '', //세부지역
		subjQty: '', //
		vehlCd: '', //차종
		tymaCd: '', //기종
		tymaCdNm: '', //
		prdtStrtDd: '', //
		prdtEndDd: '', //
		cpnyCd: '', //딜러점코드
		cpnyNm: '', //딜러점명
		causPartNo: '', //원인부품번호
		causPartNm: '', //원인부품명
		causCd: '', //원인코드
		causNm: '', //
		phmnCd: '', //현상코드
		phmnNm: '', //현상코드명
		phmnSbc: '', //현상내용
		dlvgNm: '', //실납품사
		cmpnQty: '', //처리수량
		procRt: '', //처리율
		readOnlyAuth: false //리드온리구분값
	};
}

function OP_CD_SEARCH_PARAMS() {
	return {
		opCd: '', //op코드
		partNo: '' //원인부품명
	};
}

function POP_UP_PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, CMPN_MST_POPUP, PAGING_INFO, POPUP_PARAMS, OP_CD_SEARCH_PARAMS, POP_UP_PAGING_INFO };
